import { NAVBUTTON_CLICK, SUBMENUBUTTON_CLICK, LINK_CLICK } from "../actionTypes";

const initialState = {
	navButton: 0,
	submenuButton: 0
};

export default function clicks(state = initialState, action) {
  switch (action.type) {
    case NAVBUTTON_CLICK: {
      return {
        ...state,
        navButton: action.payload.id,
        submenuButton: 0,
        link: action.payload.link,
        title: action.payload.title,
        icon: action.payload.icon,
        url: action.payload.url,
        menuitem: null,
      };
    }
    case SUBMENUBUTTON_CLICK: {
      return {
        ...state,
        navButton: action.payload.navButton,
        submenuButton: action.payload.id,
        link: action.payload.link,
        title: action.payload.title,
        icon: action.payload.icon,
        url: action.payload.url,
      };
    }

    case LINK_CLICK: {
      return {
        ...state,
        link: action.payload.link,
        title: action.payload.title,
        icon: action.payload.icon,
        navButton: action.payload.menuitem,
        submenuButton: action.payload.submenuButton,
        menuitem: action.payload.menuitem,
        url: action.payload.url,
      };
    }

    default:
      return state;
  }
}
